import * as React from 'react';
import { Command as CommandPrimitive } from 'cmdk';
import { Search } from 'lucide-react';
import { cn } from '@companion-professional/webutils';
import { passwordManagerIgnoreProps } from '../passwordManagerIgnore';

// CommandInput displays a search text box where a command can be entered.
export const CommandInput = React.forwardRef<
  React.ElementRef<typeof CommandPrimitive.Input>,
  React.ComponentPropsWithoutRef<typeof CommandPrimitive.Input>
>(({ className, ...props }, ref) => (
  <div className="flex items-center border-b px-3" cmdk-input-wrapper="">
    <Search className="mr-2 h-4 w-4 shrink-0 opacity-50" />
    <CommandPrimitive.Input
      ref={ref}
      // A command/search input is never a credential field, but cmdk renders it as a type="text" combobox that
      // password managers mistake for a username/password box and cover with their autofill overlay. Opt out of that.
      // These are defaults a caller can still override via props.
      {...passwordManagerIgnoreProps}
      className={cn(
        'placeholder:text-muted-foreground flex h-11 w-full rounded-md bg-transparent py-3 text-sm outline-none ' +
          ' disabled:cursor-not-allowed disabled:opacity-50',
        className
      )}
      {...props}
    />
  </div>
));

CommandInput.displayName = CommandPrimitive.Input.displayName;
